import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StockItem } from '../models';
import { API_BASE_URL } from '../tokens/api-base-url.token';

/** Live shelf stock for the signed-in store. */
@Injectable({ providedIn: 'root' })
export class StockService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  /** `locationId` = the store id from login. */
  getMyStock(locationId: string): Observable<StockItem[]> {
    return this.http.get<StockItem[]>(
      `${this.baseUrl}/api/sok/oms/myStock/locationId/${locationId}`,
    );
  }
}
